import React from 'react';
import { Card, CardContent, useMediaQuery, Box, Button } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { FaShareAlt, FaGift } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

// Add CSS animations
const gradientAnimation = `
  @keyframes gradientShift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
`;

const getBitAppLink = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return "https://play.google.com/store/apps/details?id=com.bnhp.payments.paymentsapp";
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "https://itunes.apple.com/us/app/bit-byt/id1182007739?ls=1&mt=8";
  }

  return "https://www.bitpay.co.il/";
};

export default function Register() {
  const isMobile = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();
  return (
    <>
      <style>{gradientAnimation}</style>
    <div style={{ 
      direction: 'rtl', 
      padding: isMobile ? '1rem 0.5rem' : '2rem', 
      maxWidth: 700, 
      margin: '0 auto',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '100vh',
      borderRadius: 0
    }}>
      <Card sx={{ 
        borderRadius: 3, 
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)', 
        mb: 3,
        background: 'linear-gradient(145deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.9) 100%)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255,255,255,0.2)'
      }}>
      <CardContent sx={{ p: isMobile ? 2 : 4 }}>
        
        {/* Modern Notice Box */}
        <div style={{
          background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
          color: '#8b4513',
          border: '1px solid rgba(252, 182, 159, 0.3)',
          borderRadius: 16,
          padding: isMobile ? '16px 14px' : '22px 24px',
          marginBottom: isMobile ? 18 : 28,
          fontSize: isMobile ? 15 : 18,
          fontWeight: 500,
          textAlign: 'right',
          boxShadow: '0 8px 32px rgba(252, 182, 159, 0.2)',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '2px',
            background: 'linear-gradient(90deg, #ff6b6b, #feca57, #48dbfb, #ff9ff3)',
            animation: 'gradientShift 3s ease infinite'
          }}></div>
          🖋️ <b>ابدأ مجانًا... لكن لا تتوقف هناك!</b><br />
          النسخة المجانية تمنحك إمكانية حل <b>5 أسئلة فقط</b> في كل قسم، وتتيح لك القسم الأول فقط في الامتحانات التجريبية.
          <br /><br />
          هل تطمح للتحضير الجاد لاختبار <b>יע"ל</b>؟ اشترك الآن وابدأ بالوصول إلى <b>جميع التمارين، كل الأسئلة، وأقوى الميزات التعليمية</b> المصممة خصيصًا لنجاحك!
        </div>

        {/* Section Title */}
        <h2 style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          fontWeight: 'bold',
          fontSize: isMobile ? 22 : 28,
          marginBottom: 18,
          textAlign: 'right'
        }}>
          الاشتراك في الموقع
        </h2>

        {/* Subscription Info */}
        <div style={{
          fontSize: isMobile ? 16 : 20,
          marginBottom: isMobile ? 18 : 24,
          color: '#222',
          fontWeight: 500,
          textAlign: 'right'
        }}>
          يمكنك الاشتراك في الموقع والاستفادة من جميع الميزات عبر دفع أحد الخيارات التالية:
        </div>

        {/* Pricing List */}
        <ul style={{
          fontSize: isMobile ? 15 : 18,
          marginBottom: isMobile ? 20 : 32,
          color: '#0d47a1',
          fontWeight: 'bold',
          listStyle: 'none',
          textAlign: 'right',
          paddingRight: isMobile ? 18 : 32
        }}>
          <li style={{ 
            marginBottom: 12,
            padding: '12px 16px',
            background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
            borderRadius: 12,
            border: '1px solid rgba(25, 118, 210, 0.1)',
            boxShadow: '0 4px 16px rgba(25, 118, 210, 0.1)'
          }}>
            💰 100 شيكل لشهر واحد
          </li>
          <li style={{ 
            marginBottom: 12,
            padding: '12px 16px',
            background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
            borderRadius: 12,
            border: '1px solid rgba(255, 152, 0, 0.1)',
            boxShadow: '0 4px 16px rgba(255, 152, 0, 0.1)',
            position: 'relative'
          }}>
            💎 250 شيكل لثلاثة أشهر 
            <span style={{
              background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
              color: 'white',
              fontSize: '0.8em',
              padding: '4px 8px',
              borderRadius: '8px',
              marginRight: 8,
              fontWeight: 'bold',
              boxShadow: '0 2px 8px rgba(255, 107, 107, 0.3)'
            }}>
              الأكثر توفيرًا
            </span>
          </li>
          <li style={{ 
            marginBottom: 12,
            padding: '12px 16px',
            background: 'linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)',
            borderRadius: 12,
            border: '1px solid rgba(156, 39, 176, 0.1)',
            boxShadow: '0 4px 16px rgba(156, 39, 176, 0.1)',
            position: 'relative'
          }}>
            🎯 450 شيكل لستة أشهر
            <span style={{
              background: 'linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%)',
              color: 'white',
              fontSize: '0.8em',
              padding: '4px 8px',
              borderRadius: '8px',
              marginRight: 8,
              fontWeight: 'bold',
              boxShadow: '0 2px 8px rgba(156, 39, 176, 0.3)'
            }}>
              توفير ممتاز
            </span>
          </li>
          <li style={{ 
            marginBottom: 12,
            padding: '12px 16px',
            background: 'linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)',
            borderRadius: 12,
            border: '1px solid rgba(76, 175, 80, 0.1)',
            boxShadow: '0 4px 16px rgba(76, 175, 80, 0.1)',
            position: 'relative'
          }}>
            🏆 800 شيكل لسنة كاملة
            <span style={{
              background: 'linear-gradient(135deg, #4caf50 0%, #388e3c 100%)',
              color: 'white',
              fontSize: '0.8em',
              padding: '4px 8px',
              borderRadius: '8px',
              marginRight: 8,
              fontWeight: 'bold',
              boxShadow: '0 2px 8px rgba(76, 175, 80, 0.3)'
            }}>
              أفضل قيمة
            </span>
          </li>
        </ul>

        {/* Payment Methods Title */}
        <div style={{
          fontSize: isMobile ? 16 : 20,
          marginBottom: isMobile ? 12 : 18,
          color: '#222',
          fontWeight: 500,
          textAlign: 'right'
        }}>
          طرق الدفع المتاحة:
        </div>

        {/* Payment Options */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: isMobile ? 2 : 3 }}>

          {/* Bit Payment */}
          <Card sx={{ 
            background: 'linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)', 
            borderRadius: 16, 
            boxShadow: '0 8px 32px rgba(76, 175, 80, 0.15)', 
            width: '100%',
            border: '1px solid rgba(76, 175, 80, 0.1)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 12px 40px rgba(76, 175, 80, 0.25)'
            }
          }}>
            <CardContent sx={{ p: isMobile ? 1.5 : 2 }}>
              <b>1. 💳 عبر تطبيق 
                <a href={getBitAppLink()} target="_blank" rel="noopener noreferrer" style={{ 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  textDecoration: 'none',
                  fontWeight: 'bold'
                }}> bit ביט (اضغط لتحميل التطبيق) </a>:</b><br />
              قم بتحويل المبلغ إلى الرقم <span style={{ 
                background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontWeight: 'bold' 
              }}>0548188407</span><br />
              <small style={{ color: '#4caf50', fontSize: '0.85em' }}>✅ الدفع عبر Bit أسرع من الدفع نقداً</small>
            </CardContent>
          </Card>

          {/* Cash Payment */}
          <Card sx={{ 
            background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)', 
            borderRadius: 16, 
            boxShadow: '0 8px 32px rgba(255, 152, 0, 0.15)', 
            width: '100%',
            border: '1px solid rgba(255, 152, 0, 0.1)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 12px 40px rgba(255, 152, 0, 0.25)'
            }
          }}>
            <CardContent sx={{ p: isMobile ? 1.5 : 2 }}>
              <b>2. 💵 الدفع نقداً:</b><br />
              اتصل بنا على الرقم <span style={{ 
                background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontWeight: 'bold' 
              }}>0548188407</span> وسنصل إليك لاستلام المبلغ.
            </CardContent>
          </Card>

          {/* Email Contact */}
          <Card sx={{ 
            background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)', 
            borderRadius: 16, 
            boxShadow: '0 8px 32px rgba(25, 118, 210, 0.15)', 
            width: '100%',
            border: '1px solid rgba(25, 118, 210, 0.1)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 12px 40px rgba(25, 118, 210, 0.25)'
            }
          }}>
            <CardContent sx={{ p: isMobile ? 1.5 : 2 }}>
              <b>3. 📧 التواصل عبر البريد الإلكتروني:</b><br />
              يمكنك التواصل معنا عبر البريد الإلكتروني: <span style={{ 
                background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontWeight: 'bold' 
              }}>yaelmasterplatform@gmail.com</span><br />
              <small style={{ color: '#4caf50', fontSize: '0.85em' }}>✅ مناسب للاستفسارات والدفع المسبق</small>
            </CardContent>
          </Card>

        </Box>

        {/* Referral System Section */}
        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderRadius: 16,
          padding: isMobile ? '20px 16px' : '24px 28px',
          marginBottom: isMobile ? 20 : 28,
          textAlign: 'right',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 8px 32px rgba(102, 126, 234, 0.3)'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '2px',
            background: 'linear-gradient(90deg, #ff6b6b, #feca57, #48dbfb, #ff9ff3)',
            animation: 'gradientShift 3s ease infinite'
          }}></div>
          
          <Box display="flex" alignItems="center" mb={2}>
            <FaShareAlt style={{ marginLeft: 8, fontSize: 24 }} />
            <h3 style={{ 
              margin: 0, 
              fontSize: isMobile ? 18 : 22, 
              fontWeight: 'bold' 
            }}>
              🎁 احصل على اشتراك مجاني!
            </h3>
          </Box>
          
          <div style={{
            fontSize: isMobile ? 15 : 17,
            marginBottom: 16,
            lineHeight: 1.6
          }}>
            ادع 3 أصدقاء للانضمام إلى منصة ياعيل ماستر واحصل على <strong>أسبوعين اشتراك مجاناً</strong>!
          </div>
          
          <div style={{
            fontSize: isMobile ? 14 : 16,
            marginBottom: 20,
            opacity: 0.9,
            lineHeight: 1.5
          }}>
            • شارك رابط الدعوة الخاص بك مع أصدقائك<br/>
            • عندما ينضم 3 أصدقاء، تحصل على المكافأة تلقائياً<br/>
            • المكافأة: 14 يوم اشتراك مجاني كامل
          </div>
          
          <Button
            variant="contained"
            startIcon={<FaGift />}
            onClick={() => navigate('/dashboard')}
            sx={{
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              fontWeight: 'bold',
              fontSize: isMobile ? 14 : 16,
              borderRadius: 12,
              border: '1px solid rgba(255,255,255,0.3)',
              '&:hover': { 
                background: 'rgba(255,255,255,0.3)',
                transform: 'translateY(-2px)'
              },
              width: isMobile ? '100%' : 'fit-content',
              transition: 'all 0.3s ease'
            }}
          >
            &nbsp;اذهب إلى لوحة التحكم لبدء الدعوات
          </Button>
        </div>

        {/* WhatsApp CTA Button */}
        <Button
          variant="contained"
          startIcon={<WhatsAppIcon />}
          sx={{
            mt: isMobile ? 3 : 4,
            background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
            color: '#fff',
            fontWeight: 'bold',
            fontSize: isMobile ? 14 : 16,
            borderRadius: 12,
            boxShadow: '0 8px 32px rgba(37, 211, 102, 0.3)',
            '&:hover': { 
              background: 'linear-gradient(135deg, #128C7E 0%, #075E54 100%)',
              boxShadow: '0 12px 40px rgba(37, 211, 102, 0.4)',
              transform: 'translateY(-2px)'
            },
            width: isMobile ? '100%' : 'fit-content',
            alignSelf: 'flex-end',
            textAlign: 'right',
            direction: 'rtl',
            transition: 'all 0.3s ease'
          }}
          href="https://wa.me/972548188407?text=مرحبًا، أرغب بتفعيل اشتراكي في منصة ياعيل ماستر"
          target="_blank"
        >
          &nbsp;تواصل معنا على واتساب لتفعيل الاشتراك
        </Button>

        {/* Post-payment note */}
        <div style={{
          fontSize: isMobile ? 14 : 16,
          color: '#d32f2f',
          marginTop: isMobile ? 18 : 32,
          fontWeight: 500,
          textAlign: 'right'
        }}>
          📢 بعد الدفع، يرجى التواصل معنا عبر واتساب أو الاتصال أو البريد الإلكتروني لتفعيل اشتراكك في أسرع وقت.
        </div>

      </CardContent>
    </Card>
    </div>
    </>
  );
} 